<ion-header *ngIf="id">
  <div class="header-with-title-subtitle-inputs constrained-content">
    <div style="width: 100%; padding-right: 20px">
      <ion-input
        placeholder="Untitled project"
        [(ngModel)]="name"
        class="title-input"
      >
      </ion-input>
      <ion-input
        placeholder="Add a description (optional)"
        [(ngModel)]="description"
        class="description-input"
      >
      </ion-input>
    </div>
    <div>
      <ion-button
        (click)="viewInInbox()"
        fill="clear"
        color="dark"
        [disabled]="isLoading"
        [hidden]="!id"
        class="button-dark-border margin-left-10"
      >
        <ion-icon name="file-tray-outline"></ion-icon>
        <span class="hidden-sm text-with-left-icon">View in inbox</span>
      </ion-button>
    </div>
  </div>
</ion-header>

<ion-content>
  <div class="constrained-content">
    <ion-grid>
      <ion-row class="row" *ngIf="!id">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="text-outline"></ion-icon>Project Details</h1>
          <p class="subtitle">Basic information about your project.</p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-item lines="full">
                <ion-label class="input-label" position="stacked">
                  Name
                  <ion-text color="warning" *ngIf="!id"
                    >(Required)</ion-text
                  ></ion-label
                >
                <ion-input
                  #nameInput
                  class="input-field"
                  [(ngModel)]="name"
                  type="text"
                  placeholder="e.g. Customer Support"
                  style="padding: 0 10px 0 10px !important"
                ></ion-input>
              </ion-item>
              <ion-item lines="full">
                <ion-label position="stacked" class="input-label"
                  >Description</ion-label
                >
                <ion-textarea
                  style="padding: 0 10px 0 10px !important"
                  class="input-field"
                  #descriptionInput
                  [(ngModel)]="description"
                  placeholder="e.g. Issues related to information technology and hardware"
                ></ion-textarea>
              </ion-item>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="row" [hidden]="!id">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="custom-bot"></ion-icon>Bot Configuration</h1>
          <p class="subtitle">
            Customize the appearance of the bot for your support team as it
            appears in Slack.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <div class="flexed-align-center">
                <div class="notification-preview">
                  <div
                    class="notification-icon"
                    style="
                      width: 50px;
                      height: 50px;
                      border-radius: 8px;
                      border: 1px solid var(--input-border-color);
                    "
                  >
                    <ion-button
                      slot="end"
                      size="full"
                      fill="clear"
                      (click)="uploadSupportLogo()"
                      class="icon-upload-button"
                    >
                      <ion-icon
                        name="cloud-upload-outline"
                        [ngClass]="{ hide: !!supportLogo }"
                      ></ion-icon>
                    </ion-button>
                    <img *ngIf="supportLogo" [src]="supportLogo" />
                  </div>
                </div>
                <ion-input
                  [(ngModel)]="supportName"
                  placeholder="Unthread"
                  class="select-outline"
                  style="font-size: 1.2rem; margin-right: 10px"
                ></ion-input>
              </div>
              <div style="padding: 10px">
                <ion-label class="input-label">AI Agent Instructions</ion-label>
                <ion-textarea
                  class="input-field"
                  [(ngModel)]="instructions"
                  placeholder="Specific instructions for the AI agent handling this project. e.g. Use a friendly tone, request specific details when handling tickets."
                  autoGrow="true"
                  rows="4"
                ></ion-textarea>
              </div>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="row" [hidden]="!id">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1>
            <ion-icon name="stopwatch-outline"></ion-icon>Support Steps & SLAs
          </h1>
          <p class="subtitle">
            Define the steps and service level agreements for handling
            conversations in this project.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <app-support-steps
                [isDefaults]="false"
                [projectId]="id"
                [initialSupportSteps]="supportSteps"
                (didChange)="supportStepsDidChange($event)"
              ></app-support-steps>
            </ion-card-content>
          </ion-card>
          <a
            href="https://docs.unthread.io/conversations/slas"
            target="_blank"
            class="settings-learn-more"
          >
            <ion-icon name="book-outline"></ion-icon>
            Learn more about SLAs and assignment rules
          </a>
        </ion-col>
      </ion-row>

      <ion-row class="row" [hidden]="!id">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1>
            <ion-icon name="settings-outline"></ion-icon>Project Configuration
          </h1>
          <p class="subtitle">
            Manage detailed settings for triage, ticket types, and working
            hours.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-item lines="full">
                <ion-label>Default Triage Channel</ion-label>
                <app-channel-selector
                  [channel]="defaultTriageChannel"
                  (channelDidChange)="channelDidChange($event)"
                  [defaultInternalOnly]="true"
                  [defaultExternalOnly]="false"
                  [hideChannelTypeFilter]="false"
                  [hideSecondaryTeams]="false"
                >
                </app-channel-selector>
              </ion-item>
              <ion-item
                lines="full"
                button
                (click)="setDefaultTicketType()"
                detail="false"
              >
                <ion-label>Default Ticket Type</ion-label>
                <ion-text slot="end" *ngIf="!defaultTicketType" color="medium"
                  >Select Ticket Type</ion-text
                >
                <ion-text slot="end" *ngIf="defaultTicketType">{{
                  defaultTicketType.name
                }}</ion-text>
                <ion-icon
                  name="chevron-down-outline"
                  slot="end"
                  *ngIf="!defaultTicketType"
                ></ion-icon>
                <ion-icon
                  name="close-circle-outline"
                  slot="end"
                  *ngIf="defaultTicketType"
                  (click)="$event.stopPropagation(); defaultTicketType = null"
                ></ion-icon>
              </ion-item>
              <ion-item
                lines="full"
                button
                (click)="setTriageMessageTemplate()"
                detail="false"
              >
                <ion-label>Triage Message Template</ion-label>
                <ion-text
                  slot="end"
                  *ngIf="!triageMessageTemplate"
                  color="medium"
                  >Select Template</ion-text
                >
                <ion-text slot="end" *ngIf="triageMessageTemplate">{{
                  triageMessageTemplate.name
                }}</ion-text>
                <ion-icon
                  name="chevron-down-outline"
                  slot="end"
                  *ngIf="!triageMessageTemplate"
                ></ion-icon>
                <ion-icon
                  name="close-circle-outline"
                  slot="end"
                  *ngIf="triageMessageTemplate"
                  (click)="
                    $event.stopPropagation();
                    triageMessageTemplateId = null;
                    triageMessageTemplate = null
                  "
                ></ion-icon>
              </ion-item>
              <ion-item lines="none" button (click)="manageWorkingHours()">
                <ion-label>Working Hours</ion-label>
                <ion-text slot="end">{{
                  workingHoursEnabled
                    ? "Enabled (overriding global settings)"
                    : "Using global settings"
                }}</ion-text>
                <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
              </ion-item>
            </ion-card-content>
          </ion-card>
          <a
            href="https://docs.unthread.io/conversations/triaging"
            target="_blank"
            class="settings-learn-more small-learn-more"
          >
            <ion-icon name="book-outline"></ion-icon>
            Learn more about triaging
          </a>
        </ion-col>
      </ion-row>

      <ion-row class="row">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="eye-outline"></ion-icon>Visibility</h1>
          <p class="subtitle">
            Control who can see and interact with this project.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-list>
                <ion-radio-group [(ngModel)]="visibility" name="visibility">
                  <ion-item lines="full">
                    <ion-icon
                      name="lock-open-outline"
                      slot="start"
                      class="medium-icon"
                    ></ion-icon>
                    <ion-label text-wrap>
                      <h2>Public</h2>
                      <p>
                        Anyone in your workspace can see this project and its
                        associated conversations.
                      </p>
                    </ion-label>
                    <ion-radio slot="end" value="public"></ion-radio>
                  </ion-item>
                  <ion-item lines="none">
                    <ion-icon
                      name="lock-closed-outline"
                      slot="start"
                      class="medium-icon"
                    ></ion-icon>
                    <ion-label text-wrap>
                      <h2>Restricted</h2>
                      <p>
                        Only you can see this project and its associated
                        conversations.
                      </p>
                    </ion-label>
                    <ion-radio slot="end" value="restricted"></ion-radio>
                  </ion-item>
                </ion-radio-group>
              </ion-list>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="row">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="briefcase-outline"></ion-icon> Type</h1>
          <p class="subtitle">
            Configure if this project handles external or internal support.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-item lines="none">
                <ion-label text-wrap>
                  <h2>Is this an external customer project?</h2>
                  <p>
                    External projects are used to manage support for customers
                    outside your organization.
                  </p>
                </ion-label>
                <label class="switch" slot="end">
                  <input type="checkbox" [(ngModel)]="isExternal" />
                  <span class="slider"></span>
                </label>
              </ion-item>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="row" [hidden]="!id">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="happy-outline"></ion-icon> Emoji Actions</h1>
          <p class="subtitle">Add reaction emojis to trigger actions</p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-list class="no-padding emoji-list" lines="none">
                <ion-item>
                  <ion-label slot="start" text-wrap>
                    <h3>Create a conversation from this message</h3>
                    <div class="permission-container">
                      <ion-button
                        color="dark"
                        fill="clear"
                        (click)="
                          showPermissionOptions('createConversation', $event)
                        "
                        class="item-accessory-button"
                      >
                        <ion-icon name="key-outline"></ion-icon>
                      </ion-button>
                      <span class="permission-subtext"
                        >Enabled for
                        {{ getPermissionLabel("createConversation") }}</span
                      >
                    </div>
                  </ion-label>
                  <ion-label text-wrap>
                    <ion-chip
                      outline
                      color="dark"
                      *ngFor="
                        let emoji of emojiActionsConfig.createConversation;
                        let i = index
                      "
                      (click)="deleteActionEmoji('createConversation', i)"
                    >
                      <ion-label>{{ emoji }}</ion-label>
                      <ion-icon name="close-circle"></ion-icon>
                    </ion-chip>
                    <ion-chip
                      [outline]="true"
                      color="primary"
                      class="btn-small"
                      (click)="openEmojiPicker('createConversation', $event)"
                    >
                      + Add
                    </ion-chip>
                  </ion-label>
                </ion-item>

                <ion-item>
                  <ion-label slot="start" text-wrap>
                    <h3>Mark a conversation as "in progress"</h3>
                    <div class="permission-container">
                      <ion-button
                        color="dark"
                        fill="clear"
                        (click)="
                          showPermissionOptions(
                            'inProgressConversation',
                            $event
                          )
                        "
                        class="item-accessory-button"
                      >
                        <ion-icon name="key-outline"></ion-icon>
                      </ion-button>
                      <span class="permission-subtext"
                        >Enabled for
                        {{ getPermissionLabel("inProgressConversation") }}</span
                      >
                    </div>
                  </ion-label>
                  <ion-label text-wrap>
                    <ion-chip
                      outline
                      color="dark"
                      *ngFor="
                        let emoji of emojiActionsConfig.inProgressConversation;
                        let i = index
                      "
                      (click)="deleteActionEmoji('inProgressConversation', i)"
                    >
                      <ion-label>{{ emoji }}</ion-label>
                      <ion-icon name="close-circle"></ion-icon>
                    </ion-chip>
                    <ion-chip
                      [outline]="true"
                      color="primary"
                      class="btn-small"
                      (click)="
                        openEmojiPicker('inProgressConversation', $event)
                      "
                    >
                      + Add
                    </ion-chip>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-label slot="start" text-wrap>
                    <h3>Mark a conversation as "on hold"</h3>
                    <div class="permission-container">
                      <ion-button
                        color="dark"
                        fill="clear"
                        (click)="
                          showPermissionOptions('onHoldConversation', $event)
                        "
                        class="item-accessory-button"
                      >
                        <ion-icon name="key-outline"></ion-icon>
                      </ion-button>
                      <span class="permission-subtext"
                        >Enabled for
                        {{ getPermissionLabel("onHoldConversation") }}</span
                      >
                    </div>
                  </ion-label>
                  <ion-label text-wrap>
                    <ion-chip
                      outline
                      color="dark"
                      *ngFor="
                        let emoji of emojiActionsConfig.onHoldConversation;
                        let i = index
                      "
                      (click)="deleteActionEmoji('onHoldConversation', i)"
                    >
                      <ion-label>{{ emoji }}</ion-label>
                      <ion-icon name="close-circle"></ion-icon>
                    </ion-chip>
                    <ion-chip
                      [outline]="true"
                      color="primary"
                      class="btn-small"
                      (click)="openEmojiPicker('onHoldConversation', $event)"
                    >
                      + Add
                    </ion-chip>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-label slot="start" text-wrap>
                    <h3>Mark a conversation as "closed"</h3>
                    <div class="permission-container">
                      <ion-button
                        color="dark"
                        fill="clear"
                        (click)="
                          showPermissionOptions('closeConversation', $event)
                        "
                        class="item-accessory-button"
                      >
                        <ion-icon name="key-outline"></ion-icon>
                      </ion-button>
                      <span class="permission-subtext"
                        >Enabled for
                        {{ getPermissionLabel("closeConversation") }}</span
                      >
                    </div>
                  </ion-label>
                  <ion-label text-wrap>
                    <ion-chip
                      outline
                      color="dark"
                      *ngFor="
                        let emoji of emojiActionsConfig.closeConversation;
                        let i = index
                      "
                      (click)="deleteActionEmoji('closeConversation', i)"
                    >
                      <ion-label>{{ emoji }}</ion-label>
                      <ion-icon name="close-circle"></ion-icon>
                    </ion-chip>
                    <ion-chip
                      [outline]="true"
                      color="primary"
                      class="btn-small"
                      (click)="openEmojiPicker('closeConversation', $event)"
                    >
                      + Add
                    </ion-chip>
                  </ion-label>
                </ion-item>

                <ion-item>
                  <ion-label slot="start" text-wrap>
                    <h3>Suggest an AI response to this message</h3>
                    <span class="permission-subtext"
                      >Enabled for Agent Only</span
                    >
                  </ion-label>
                  <ion-label text-wrap>
                    <ion-chip
                      outline
                      color="dark"
                      *ngFor="
                        let emoji of emojiActionsConfig.suggestResponse;
                        let i = index
                      "
                      (click)="deleteActionEmoji('suggestResponse', i)"
                    >
                      <ion-label>{{ emoji }}</ion-label>
                      <ion-icon name="close-circle"></ion-icon>
                    </ion-chip>
                    <ion-chip
                      [outline]="true"
                      color="primary"
                      class="btn-small"
                      (click)="openEmojiPicker('suggestResponse', $event)"
                    >
                      + Add
                    </ion-chip>
                  </ion-label>
                </ion-item>

                <ion-item>
                  <ion-label slot="start" text-wrap>
                    <h3>Lock conversation from reopening</h3>
                    <span class="permission-subtext"
                      >Enabled for Agent Only</span
                    >
                  </ion-label>
                  <ion-label text-wrap>
                    <ion-chip
                      outline
                      color="dark"
                      *ngFor="
                        let emoji of emojiActionsConfig.lockConversation;
                        let i = index
                      "
                      (click)="deleteActionEmoji('lockConversation', i)"
                    >
                      <ion-label>{{ emoji }}</ion-label>
                      <ion-icon name="close-circle"></ion-icon>
                    </ion-chip>
                    <ion-chip
                      [outline]="true"
                      color="primary"
                      class="btn-small"
                      (click)="openEmojiPicker('lockConversation', $event)"
                    >
                      + Add
                    </ion-chip>
                  </ion-label>
                </ion-item>

                <ion-item>
                  <ion-label slot="start" text-wrap>
                    <h3>Lock from reopening and exclude from analytics</h3>
                    <span class="permission-subtext"
                      >Enabled for Agent Only</span
                    >
                  </ion-label>
                  <ion-label text-wrap>
                    <ion-chip
                      outline
                      color="dark"
                      *ngFor="
                        let emoji of emojiActionsConfig.disableAnalyticsAndLock;
                        let i = index
                      "
                      (click)="deleteActionEmoji('disableAnalyticsAndLock', i)"
                    >
                      <ion-label>{{ emoji }}</ion-label>
                      <ion-icon name="close-circle"></ion-icon>
                    </ion-chip>
                    <ion-chip
                      [outline]="true"
                      color="primary"
                      class="btn-small"
                      (click)="
                        openEmojiPicker('disableAnalyticsAndLock', $event)
                      "
                    >
                      + Add
                    </ion-chip>
                  </ion-label>
                </ion-item>

                <ion-item>
                  <ion-label slot="start" text-wrap>
                    <h3>Set message as first response</h3>
                    <span class="permission-subtext"
                      >Enabled for Agent Only</span
                    >
                  </ion-label>
                  <ion-label text-wrap>
                    <ion-chip
                      outline
                      color="dark"
                      *ngFor="
                        let emoji of emojiActionsConfig.setFirstResponseMessage;
                        let i = index
                      "
                      (click)="deleteActionEmoji('setFirstResponseMessage', i)"
                    >
                      <ion-label>{{ emoji }}</ion-label>
                      <ion-icon name="close-circle"></ion-icon>
                    </ion-chip>
                    <ion-chip
                      [outline]="true"
                      color="primary"
                      class="btn-small"
                      (click)="
                        openEmojiPicker('setFirstResponseMessage', $event)
                      "
                    >
                      + Add
                    </ion-chip>
                  </ion-label>
                </ion-item>

                <ion-item>
                  <ion-label slot="start" text-wrap>
                    <h3>Set message as resolving message</h3>
                    <span class="permission-subtext"
                      >Enabled for Agent Only</span
                    >
                  </ion-label>
                  <ion-label text-wrap>
                    <ion-chip
                      outline
                      color="dark"
                      *ngFor="
                        let emoji of emojiActionsConfig.setResolutionMessage;
                        let i = index
                      "
                      (click)="deleteActionEmoji('setResolutionMessage', i)"
                    >
                      <ion-label>{{ emoji }}</ion-label>
                      <ion-icon name="close-circle"></ion-icon>
                    </ion-chip>
                    <ion-chip
                      [outline]="true"
                      color="primary"
                      class="btn-small"
                      (click)="openEmojiPicker('setResolutionMessage', $event)"
                    >
                      + Add
                    </ion-chip>
                  </ion-label>
                </ion-item>
              </ion-list>
              <ion-button
                fill="clear"
                routerLink="/dashboard/automations"
                routerDirection="root"
              >
                <ion-icon name="cog-outline" class="padded-icon"></ion-icon>
                Set up custom emoji actions via Automations
              </ion-button>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="row" *ngIf="showEscalationSettings">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1>
            <ion-icon name="alert-circle-outline"></ion-icon> Escalation
            Settings
          </h1>
          <p class="subtitle">
            Configure the escalation settings for this project.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-item lines="none">
                <ion-label text-wrap>
                  <h2>Send user-facing notifications</h2>
                  <p>
                    When enabled, the support bot will send a notification to
                    the main conversation thread when an escalation occurs.
                  </p>
                </ion-label>
                <label class="switch" slot="end">
                  <input
                    type="checkbox"
                    [(ngModel)]="escalationSettings.sendUserFacingNotifications"
                  />
                  <span class="slider"></span>
                </label>
              </ion-item>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="row" *ngIf="shouldShowProjectLevelSlackInboxConfig">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="logo-slack"></ion-icon> Slack Settings</h1>
          <p class="subtitle">Configure Slack settings for this project.</p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-item lines="full">
                <ion-label text-wrap>
                  <h2>Show in Slack ticket creation shortcut</h2>
                  <p>
                    When enabled, this project and its ticket types will appear
                    in the Slack ticket creation shortcut.
                  </p>
                </ion-label>
                <ion-select
                  slot="end"
                  interface="popover"
                  [(ngModel)]="
                    slackInboxConfig.hideProjectInDirectTicketCreation
                  "
                  [compareWith]="genericCompareFn"
                  class="select-outline card-accessory-select"
                >
                  <ion-select-option [value]="null"
                    >Default ({{
                      tenantSlackInboxConfig?.defaultHideProjectsInDirectTicketCreation
                        ? "Hidden"
                        : "Shown"
                    }})</ion-select-option
                  >
                  <ion-select-option [value]="true">Hidden</ion-select-option>
                  <ion-select-option [value]="false">Shown</ion-select-option>
                </ion-select>
              </ion-item>
              <ion-item lines="full">
                <ion-label text-wrap>
                  <h2>Show success modal after updating a conversation</h2>
                  <p>
                    Show confirmation messages for Slack shortcuts (Close, On
                    Hold, Snooze). This setting overrides the tenant-level
                    setting.
                  </p>
                </ion-label>
                <ion-select
                  slot="end"
                  interface="popover"
                  [(ngModel)]="
                    slackInboxConfig.suppressManageConversationsSuccessModal
                  "
                  [compareWith]="genericCompareFn"
                  class="select-outline card-accessory-select"
                >
                  <ion-select-option [value]="null"
                    >Default ({{
                      tenantSlackInboxConfig?.suppressManageConversationsSuccessModal
                        ? "Hidden"
                        : "Shown"
                    }})</ion-select-option
                  >
                  <ion-select-option [value]="true">Hidden</ion-select-option>
                  <ion-select-option [value]="false">Shown</ion-select-option>
                </ion-select>
              </ion-item>
              <ion-item lines="none">
                <ion-label text-wrap>
                  <h2>Enable automated ticketing for agents and teammates</h2>
                  <p>
                    Allow agent and teammate messages to trigger automated
                    ticket creation in this project
                  </p>
                </ion-label>
                <ion-select
                  slot="end"
                  interface="popover"
                  [(ngModel)]="enableAgentAutomatedTicketing"
                  class="select-outline card-accessory-select"
                  [compareWith]="genericCompareFn"
                >
                  <ion-select-option [value]="false">
                    Disabled
                  </ion-select-option>
                  <ion-select-option [value]="true">
                    Enabled
                  </ion-select-option>
                </ion-select>
              </ion-item>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="row" [hidden]="!id">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1>
            <ion-icon name="cellular-outline"></ion-icon>Priority Label
            Customization
          </h1>
          <p class="subtitle">
            Customize the display text for priority levels.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-list>
                <!-- LOW Priority Section -->
                <ion-item lines="none">
                  <ion-label class="priority-section-label">
                    <ion-icon
                      [name]="getIconForPriority('LOW')"
                      class="padded-icon"
                    ></ion-icon>
                    <strong>Low Priority</strong>
                  </ion-label>
                </ion-item>
                <ion-list style="padding-left: 20px">
                  <div class="flexed-align-center">
                    <div
                      (click)="openPriorityEmojiPicker('LOW', $event)"
                      aria-label="Selected emoji for Low priority. Click to change."
                      slot="end"
                      class="emoji-picker-container"
                    >
                      <ng-container *ngIf="priorityLabelMapForm.LOW.EMOJI">
                        <img
                          *ngIf="
                            isURL(priorityLabelMapForm.LOW.EMOJI | colonToEmoji)
                          "
                          [src]="priorityLabelMapForm.LOW.EMOJI | colonToEmoji"
                          alt="Emoji"
                          class="action-icon"
                          class="emoji-image"
                        />
                        <span
                          *ngIf="
                            !isURL(
                              priorityLabelMapForm.LOW.EMOJI | colonToEmoji
                            )
                          "
                          class="action-icon"
                          >{{
                            priorityLabelMapForm.LOW.EMOJI | colonToEmoji
                          }}</span
                        >
                      </ng-container>
                      <ng-container *ngIf="!priorityLabelMapForm.LOW.EMOJI">
                        <span>
                          {{
                            defaultPriorityLabelMap.LOW.EMOJI || "Select Emoji"
                          }}
                        </span>
                      </ng-container>
                      <button
                        *ngIf="priorityLabelMapForm.LOW.EMOJI"
                        (click)="
                          priorityLabelMapForm.LOW.EMOJI = null;
                          $event.stopPropagation()
                        "
                        class="clear-button"
                      >
                        <ion-icon name="close-outline"></ion-icon>
                      </button>
                    </div>
                    <ion-input
                      [(ngModel)]="priorityLabelMapForm.LOW.LABEL"
                      [placeholder]="defaultPriorityLabelMap.LOW.LABEL"
                      slot="end"
                    ></ion-input>
                  </div>
                  <ion-item>
                    <ion-label>Description</ion-label>
                    <ion-input
                      [(ngModel)]="priorityLabelMapForm.LOW.DESCRIPTION"
                      [placeholder]="FORM_PLACEHOLDER_DESCRIPTIONS.LOW"
                      slot="end"
                    ></ion-input>
                  </ion-item>
                </ion-list>

                <!-- MEDIUM Priority Section -->
                <ion-item lines="none">
                  <ion-label class="priority-section-label">
                    <ion-icon
                      [name]="getIconForPriority('MEDIUM')"
                      class="padded-icon"
                    ></ion-icon>
                    <strong>Medium Priority</strong>
                  </ion-label>
                </ion-item>
                <ion-list style="padding-left: 20px">
                  <div class="flexed-align-center">
                    <div
                      (click)="openPriorityEmojiPicker('MEDIUM', $event)"
                      aria-label="Selected emoji for Medium priority. Click to change."
                      slot="end"
                      class="emoji-picker-container"
                    >
                      <ng-container *ngIf="priorityLabelMapForm.MEDIUM.EMOJI">
                        <img
                          *ngIf="
                            isURL(
                              priorityLabelMapForm.MEDIUM.EMOJI | colonToEmoji
                            )
                          "
                          [src]="
                            priorityLabelMapForm.MEDIUM.EMOJI | colonToEmoji
                          "
                          alt="Emoji"
                          class="action-icon"
                          class="emoji-image"
                        />
                        <span
                          *ngIf="
                            !isURL(
                              priorityLabelMapForm.MEDIUM.EMOJI | colonToEmoji
                            )
                          "
                          class="action-icon"
                          >{{
                            priorityLabelMapForm.MEDIUM.EMOJI | colonToEmoji
                          }}</span
                        >
                      </ng-container>
                      <ng-container *ngIf="!priorityLabelMapForm.MEDIUM.EMOJI">
                        <span>
                          {{
                            defaultPriorityLabelMap.MEDIUM.EMOJI ||
                              "Select Emoji"
                          }}
                        </span>
                      </ng-container>
                      <button
                        *ngIf="priorityLabelMapForm.MEDIUM.EMOJI"
                        (click)="
                          priorityLabelMapForm.MEDIUM.EMOJI = null;
                          $event.stopPropagation()
                        "
                        class="clear-button"
                      >
                        <ion-icon name="close-outline"></ion-icon>
                      </button>
                    </div>
                    <ion-input
                      [(ngModel)]="priorityLabelMapForm.MEDIUM.LABEL"
                      [placeholder]="defaultPriorityLabelMap.MEDIUM.LABEL"
                      slot="end"
                    ></ion-input>
                  </div>
                  <ion-item>
                    <ion-label>Description</ion-label>
                    <ion-input
                      [(ngModel)]="priorityLabelMapForm.MEDIUM.DESCRIPTION"
                      [placeholder]="FORM_PLACEHOLDER_DESCRIPTIONS.MEDIUM"
                      slot="end"
                    ></ion-input>
                  </ion-item>
                </ion-list>

                <!-- HIGH Priority Section -->
                <ion-item lines="none">
                  <ion-label class="priority-section-label">
                    <ion-icon
                      [name]="getIconForPriority('HIGH')"
                      class="padded-icon"
                    ></ion-icon>
                    <strong>High Priority</strong>
                  </ion-label>
                </ion-item>
                <ion-list style="padding-left: 20px">
                  <div class="flexed-align-center">
                    <div
                      (click)="openPriorityEmojiPicker('HIGH', $event)"
                      aria-label="Selected emoji for High priority. Click to change."
                      slot="end"
                      class="emoji-picker-container"
                    >
                      <ng-container *ngIf="priorityLabelMapForm.HIGH.EMOJI">
                        <img
                          *ngIf="
                            isURL(
                              priorityLabelMapForm.HIGH.EMOJI | colonToEmoji
                            )
                          "
                          [src]="priorityLabelMapForm.HIGH.EMOJI | colonToEmoji"
                          alt="Emoji"
                          class="action-icon"
                          class="emoji-image"
                        />
                        <span
                          *ngIf="
                            !isURL(
                              priorityLabelMapForm.HIGH.EMOJI | colonToEmoji
                            )
                          "
                          class="action-icon"
                          >{{
                            priorityLabelMapForm.HIGH.EMOJI | colonToEmoji
                          }}</span
                        >
                      </ng-container>
                      <ng-container *ngIf="!priorityLabelMapForm.HIGH.EMOJI">
                        <span>
                          {{
                            defaultPriorityLabelMap.HIGH.EMOJI || "Select Emoji"
                          }}
                        </span>
                      </ng-container>
                      <button
                        *ngIf="priorityLabelMapForm.HIGH.EMOJI"
                        (click)="
                          priorityLabelMapForm.HIGH.EMOJI = null;
                          $event.stopPropagation()
                        "
                        class="clear-button"
                      >
                        <ion-icon name="close-outline"></ion-icon>
                      </button>
                    </div>
                    <ion-input
                      [(ngModel)]="priorityLabelMapForm.HIGH.LABEL"
                      [placeholder]="defaultPriorityLabelMap.HIGH.LABEL"
                      slot="end"
                    ></ion-input>
                  </div>
                  <ion-item>
                    <ion-label>Description</ion-label>
                    <ion-input
                      [(ngModel)]="priorityLabelMapForm.HIGH.DESCRIPTION"
                      [placeholder]="FORM_PLACEHOLDER_DESCRIPTIONS.HIGH"
                      slot="end"
                    ></ion-input>
                  </ion-item>
                </ion-list>

                <!-- CRITICAL Priority Section -->
                <ion-item lines="none">
                  <ion-label class="priority-section-label">
                    <ion-icon
                      [name]="getIconForPriority('CRITICAL')"
                      class="padded-icon"
                    ></ion-icon>
                    <strong>Critical Priority</strong>
                  </ion-label>
                </ion-item>
                <ion-list style="padding-left: 20px">
                  <div class="flexed-align-center">
                    <div
                      (click)="openPriorityEmojiPicker('CRITICAL', $event)"
                      aria-label="Selected emoji for Critical priority. Click to change."
                      slot="end"
                      class="emoji-picker-container"
                    >
                      <ng-container *ngIf="priorityLabelMapForm.CRITICAL.EMOJI">
                        <img
                          *ngIf="
                            isURL(
                              priorityLabelMapForm.CRITICAL.EMOJI | colonToEmoji
                            )
                          "
                          [src]="
                            priorityLabelMapForm.CRITICAL.EMOJI | colonToEmoji
                          "
                          alt="Emoji"
                          class="action-icon"
                          class="emoji-image"
                        />
                        <span
                          *ngIf="
                            !isURL(
                              priorityLabelMapForm.CRITICAL.EMOJI | colonToEmoji
                            )
                          "
                          class="action-icon"
                          >{{
                            priorityLabelMapForm.CRITICAL.EMOJI | colonToEmoji
                          }}</span
                        >
                      </ng-container>
                      <ng-container
                        *ngIf="!priorityLabelMapForm.CRITICAL.EMOJI"
                      >
                        <span>
                          {{
                            defaultPriorityLabelMap.CRITICAL.EMOJI ||
                              "Select Emoji"
                          }}
                        </span>
                      </ng-container>
                      <button
                        *ngIf="priorityLabelMapForm.CRITICAL.EMOJI"
                        (click)="
                          priorityLabelMapForm.CRITICAL.EMOJI = null;
                          $event.stopPropagation()
                        "
                        class="clear-button"
                      >
                        <ion-icon name="close-outline"></ion-icon>
                      </button>
                    </div>
                    <ion-input
                      [(ngModel)]="priorityLabelMapForm.CRITICAL.LABEL"
                      [placeholder]="defaultPriorityLabelMap.CRITICAL.LABEL"
                      slot="end"
                    ></ion-input>
                  </div>
                  <ion-item>
                    <ion-label>Description</ion-label>
                    <ion-input
                      [(ngModel)]="priorityLabelMapForm.CRITICAL.DESCRIPTION"
                      [placeholder]="FORM_PLACEHOLDER_DESCRIPTIONS.CRITICAL"
                      slot="end"
                    ></ion-input>
                  </ion-item>
                </ion-list>
              </ion-list>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="row" [hidden]="!id">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1>
            <ion-icon name="sparkles-outline"></ion-icon>AI Prefill Settings
          </h1>
          <p class="subtitle">
            Configure AI prefill settings for this project.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-item lines="none">
                <ion-label text-wrap>
                  <h2>Auto-approve AI Prefills</h2>
                  <p>
                    Automatically approve AI prefilled values when a ticket
                    reaches a specific status.
                    <ion-icon
                      name="information-circle"
                      class="icon-padded-left"
                      ngxTippy
                      data-tippy-content="When a ticket is updated to this status, or a downstream status, the AI will automatically approve prefilled values."
                    ></ion-icon>
                  </p>
                </ion-label>
                <ion-chip
                  mode="ios"
                  class="select-chip select-outline"
                  [outline]="true"
                  (click)="showSubStatusPopover($event)"
                  [disabled]="isLoading"
                >
                  <ion-label [ngClass]="{ 'text-muted': !selectedSubStatus }">
                    <span *ngIf="selectedSubStatus">
                      <ion-icon
                        *ngIf="selectedSubStatus?.icon"
                        [name]="selectedSubStatus?.icon"
                        [class]="selectedSubStatus?.iconClass"
                        style="margin: 0 5px 2px 0"
                      ></ion-icon>
                      {{ selectedSubStatus.name }} ({{
                        getStatusTypeLabel(selectedSubStatus.type)
                      }})
                    </span>
                    <span *ngIf="!selectedSubStatus">None</span>
                    <ion-icon
                      name="chevron-down-outline"
                      class="icon-padded-left button-icon"
                    ></ion-icon>
                  </ion-label>
                </ion-chip>
              </ion-item>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="row" [hidden]="!id">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="code-outline"></ion-icon>Developer Settings</h1>
          <p class="subtitle">Configure developer settings for this project.</p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-item lines="none">
                <ion-label text-wrap>
                  <h2>Service Accounts & API Keys</h2>
                  <p>
                    Provision access to this project for your own custom
                    applications.
                  </p>
                </ion-label>
                <ion-button
                  slot="end"
                  fill="outline"
                  (click)="showServiceAccounts()"
                  [disabled]="isLoading"
                >
                  <ion-icon name="key-outline" class="padded-icon"></ion-icon>
                  Manage Service Accounts
                </ion-button>
              </ion-item>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="row" [hidden]="!id">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="warning-outline"></ion-icon>Danger Zone</h1>
          <p class="subtitle">
            Irreversible and destructive actions for this project.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-item lines="none">
                <ion-label text-wrap>
                  <h2><ion-text color="danger">Delete Project</ion-text></h2>
                  <p>
                    Once you delete a project, there is no going back. All
                    customers in this project will be moved to the default
                    project.
                  </p>
                </ion-label>
                <ion-button
                  slot="end"
                  fill="outline"
                  color="danger"
                  (click)="showDeleteConfirmation()"
                  [disabled]="isLoading"
                >
                  <ion-icon name="trash-outline" class="padded-icon"></ion-icon>
                  Delete Project
                </ion-button>
              </ion-item>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <div class="footer-spacer"></div>
</ion-content>

<ion-footer class="footer footer-always-visible">
  <div class="constrained-content flex-space-between">
    <div>
      <ion-button (click)="submit()" [disabled]="isLoading">
        Save changes
        <ion-spinner
          name="crescent"
          [hidden]="!isLoading"
          class="margin-left-10"
        ></ion-spinner>
      </ion-button>
    </div>
  </div>
</ion-footer>
